import { Link } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  BookOpen,
  Rocket,
  Code,
  ShieldCheck,
  Users,
} from "@phosphor-icons/react";

const GUIDES = [
  {
    icon: Rocket,
    title: "Getting Started",
    description:
      "Create your workspace, invite your team, and set up your first project in under 5 minutes.",
    href: "#",
  },
  {
    icon: BookOpen,
    title: "Task Management",
    description:
      "Learn how to create tasks, use boards, set priorities, and manage deadlines effectively.",
    href: "#",
  },
  {
    icon: Users,
    title: "Team Collaboration",
    description:
      "Comments, mentions, assignments, and real-time updates to keep your team aligned.",
    href: "#",
  },
  {
    icon: Code,
    title: "Workflow Automation",
    description:
      "Build custom automations with triggers, conditions, and actions — no code required.",
    href: "#",
  },
  {
    icon: ShieldCheck,
    title: "Admin & Security",
    description:
      "Manage users, roles, SSO, audit logs, and data retention policies for your workspace.",
    href: "#",
  },
];

export function DocsPage() {
  return (
    <main className="pt-28 pb-20">
      <div className="mx-auto max-w-4xl px-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-medium text-slate-500 dark:text-slate-400 hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        <div className="mt-8 text-center">
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-4xl">
            Documentation
          </h1>
          <p className="mt-4 text-lg text-slate-600 dark:text-slate-300 max-w-xl mx-auto">
            Everything you need to get the most out of Opero. Guides, tutorials,
            and reference materials for your team.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2">
          {GUIDES.map((guide) => (
            <div
              key={guide.title}
              className="group rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-7 transition-all duration-300 hover:border-primary-500/30 dark:hover:border-primary-400/20 hover:shadow-lg"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500/10 to-primary-400/10 dark:from-primary-500/20 dark:to-primary-400/20 transition-transform duration-300 group-hover:scale-110">
                <guide.icon
                  size={22}
                  weight="duotone"
                  className="text-primary-500 dark:text-primary-400"
                />
              </div>
              <h3 className="mt-4 text-base font-semibold text-slate-900 dark:text-white">
                {guide.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                {guide.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-500 dark:text-primary-400 group-hover:gap-2 transition-all">
                Read guide
                <ArrowRight size={12} weight="bold" />
              </span>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center rounded-2xl border border-slate-200/60 dark:border-slate-800/60 bg-white dark:bg-slate-900 p-8">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-white">
            Need help?
          </h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
            Can't find what you're looking for? Our support team is here to
            help.
          </p>
          <a
            href="mailto:corporate@digiits.com"
            className="mt-4 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-primary-500/25 transition-all duration-200 hover:shadow-xl"
          >
            Contact Support
          </a>
        </div>
      </div>
    </main>
  );
}
